import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap'
import { FaArrowLeft } from 'react-icons/fa'
import Navbar from './Navbar'
import defaultImg from '../Assets/Assests/BannerImg.jpg'

const Podcasts = () => {
  const navigate = useNavigate()
  const [podcasts, setPodcasts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios
      .get('https://aimuseumbackend.teslabird.com/membership/podcasts/')
      .then((response) => {
        setPodcasts(response.data)
        setLoading(false)
      })
      .catch((error) => {
        console.error('Error fetching podcasts:', error)
        setLoading(false)
      })
  }, [])

  const handlePodcastClick = async (id, topic, banner_image_url, path_url) => {
    try {
      const response = await axios.get(
        `https://aimuseumbackend.teslabird.com/membership/expertdetails/${id}/`
      )
      navigate(`/podcast-details/${id}`, {
        state: {
          details: {
            ...response.data,
            topic,
            banner_image_url,
            path_url,
          },
        },
      })
    } catch (error) {
      console.error('Error fetching podcast details:', error)
    }
  }

  return (
    <>
      <Navbar />
      <div className='container-fluid py-4 bg-container'>
        <button
          className='btn btn-light d-flex align-items-center'
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft className='me-2' /> Back
        </button>
        <Container className='mt-5 p-4 bg-white rounded-4 shadow-lg'>
          <h2 className='text-primary text-center mb-5'>Podcasts</h2>
          {loading ? (
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <Row className='g-4'>
              {podcasts.map((podcast) => (
                <Col key={podcast.id} xs={12} sm={6} md={4} lg={3}>
                  <Card
                    className='shadow-sm podcast-card'
                    onClick={() =>
                      handlePodcastClick(
                        podcast.expertdetails_id_id,
                        podcast.topic,
                        podcast.banner_image_url,
                        podcast.path_url
                      )
                    }
                  >
                    <Card.Img
                      variant='top'
                      src={podcast.banner_image_url || defaultImg}
                      alt='Podcast Cover'
                      className='podcast-img'
                    />
                    {/* <Card.Body>
                      <Card.Title className='text-primary text-center'>
                        {podcast.topic}
                      </Card.Title>
                      <Card.Subtitle className='text-muted text-center'>
                        {podcast.expert_name} - {podcast.profession}
                      </Card.Subtitle>
                    </Card.Body> */}
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>
      <style>
        {`
          .podcast-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  border-radius: 12px; 
  overflow: hidden;    
}
          .podcast-card:hover {
            transform: scale(1.05);
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          }
          .podcast-img {
            height: 250px;
            object-fit: fill;
            border-radius: 8px; 
          }
          .card-body {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
        `}
      </style>
    </>
  )
}

export default Podcasts
